import React, { useState } from "react";
import notes from "../assets/./images/notes.png";
import doubleTick from "../assets/images/double-tick.png";
import plusIcon from "../assets/images/plus.png";
import {
  useAddTodoMutation,
  useCompleteAllTodosMutation,
  useDeleteTodoMutation,
  useGetTodosQuery,
} from "../features/api/apiSlice";
import Error from "./ui/Error";
import Spinner from "./ui/Spinner";

const Header = () => {
  const [input, setInput] = useState("");
  const [addTodo, { isLoading: isAddLoading, isError: isAddError }] = useAddTodoMutation();
  const { data: todos, isLoading: isFetchLoading } = useGetTodosQuery({ color: [], status: "all" });
  const [completeAllTodos, { isLoading: isCompleteLoading }] = useCompleteAllTodosMutation();
  const [deleteTodo, { isLoading: isDeleteLoading }] = useDeleteTodoMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    addTodo({ text: input, color: "", completed: false });
    setInput("");
  };

  const handleCompleteAll = () => {
    todos.forEach((todo) => {
      completeAllTodos(todo.id);
    });
  };
  const handleClearCompleted = () => {
    todos.forEach((todo) => {
      if (todo.completed) {
        deleteTodo(todo.id);
      }
    });
  };
  return (
    <>
      <div>
        <form onSubmit={handleSubmit} className='flex items-center bg-gray-100 px-4 py-4 rounded-md'>
          <img src={notes} className='w-6 h-6' alt='Add todo' />
          <input
            value={input}
            type='text'
            placeholder='Type your todo'
            className='w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500'
            onChange={(e) => setInput(e.target.value)}
          />
          {isAddLoading ? (
            <Spinner customStyle='w-6 h-6 border-4 ' />
          ) : (
            <button
              disabled={isAddLoading}
              type='submit'
              className={` appearance-none w-8 h-8 bg-[url(${plusIcon})] bg-no-repeat bg-contain`}
            ></button>
          )}
        </form>

        <ul className='flex justify-between my-4 text-xs text-gray-500'>
          <li onClick={handleCompleteAll} className='flex space-x-1 cursor-pointer'>
            <img className='w-4 h-4' src={doubleTick} alt='Complete' />
            <button disabled={isFetchLoading || isCompleteLoading} onClick={handleCompleteAll}>
              <span>Complete All Tasks</span>
            </button>
          </li>

          <li className='cursor-pointer'>
            <button onClick={handleClearCompleted} disabled={isDeleteLoading}>
              Clear completed
            </button>
          </li>
        </ul>
      </div>
      {isAddError && <Error message='Adding new todo failed' />}
      <hr className='mt-4' />
    </>
  );
};

export default Header;
